import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {bindActionCreators} from "redux";
import * as layoutActions from "../../actions/layoutActions";
import * as strategicPlanLocations from "../../constants/strategicPlan/strategicPlanLocations";
import GridRow from "../../components/common/GridRow";
import GridColumn from "../../components/common/GridColumn";
import Button from "../../components/common/buttons/Button";

export class StrategicPlanAdminWrapper extends React.PureComponent {
    constructor(props) {
        super(props);

        this.getCurrentLocation = this.getCurrentLocation.bind(this);
        this.navButtonClick = this.navButtonClick.bind(this);
    }

    componentDidMount(){
        this.props.actions.updatePageTitle("Strategic Plan Admin");
    }


    navButtonClick(event, location){
        event.preventDefault();

        if(location === this.getCurrentLocation()) return;

        this.props.history.push(location);
    }

    getCurrentLocation(){
        return this.props.location.pathname;
    }

    render() {
        const {component: Component} = this.props;

        return (
            <GridRow isPageNav>
                <GridColumn isPageNavLinks
                            isStickyLinks
                            large="3">
                    <Button btnClass={this.getCurrentLocation() === strategicPlanLocations.MANAGE_PLANS.path ? "is-active" : ""}
                            onClick={(event) => this.navButtonClick(event, strategicPlanLocations.MANAGE_PLANS.path)}
                            label={"Plans"}
                            name={strategicPlanLocations.MANAGE_PLANS.path} />
                    <Button btnClass={this.getCurrentLocation() === strategicPlanLocations.MANAGE_RESOURCES.path ? "is-active" : ""}
                            onClick={(event) => this.navButtonClick(event, strategicPlanLocations.MANAGE_RESOURCES.path)}
                            label={"Resources"}
                            name={strategicPlanLocations.MANAGE_RESOURCES.path} />
                    <Button btnClass={this.getCurrentLocation() === strategicPlanLocations.MANAGE_GOALS.path ? "is-active" : ""}
                            onClick={(event) => this.navButtonClick(event, strategicPlanLocations.MANAGE_GOALS.path)}
                            label={"Goals"}
                            name={strategicPlanLocations.MANAGE_GOALS.path} />
                </GridColumn>

                <GridColumn isPageNavContent large="9">
                    <Component {...this.props} />
                </GridColumn>
            </GridRow>
        );
    }
}

StrategicPlanAdminWrapper.propTypes = {
    actions: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    component: PropTypes.func.isRequired,
    layout: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
};

function mapDispatchToProps(dispatch) {
    const combinedActions = Object.assign(
        {},
        layoutActions
    );

    return {
        actions: bindActionCreators(combinedActions, dispatch)
    };
}

export default withRouter(connect(null, mapDispatchToProps)(StrategicPlanAdminWrapper));